export default {
  title: "Bienvenido a Antipartido",
  subtitle: "Crea tu identidad digital ciudadana para participar en la democracia del futuro",
  whatIs: {
    title: "¿Qué es Antipartido?",
    description:
      "Una plataforma cívica descentralizada que permite a los ciudadanos mexicanos participar en decisiones gubernamentales mediante tecnología blockchain, garantizando transparencia y anonimato en cada votación.",
    features: {
      anonymous: "100%\nAnónimo",
      verifiable: "Verificable en\nBlockchain",
      biometric: "Seguridad\nBiométrica",
      oneVote: "Un Ciudadano =\nUn Voto",
    },
  },
  buttons: {
    connect: "Iniciar sesión",
    register: "Regístrate",
  },
  or: "o",
  faqLink: "¿Tienes dudas? Ver preguntas frecuentes",
}
